<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <b-badge class="bg-blue">
            <i class="fa fa-file mr-2"></i>
            Change of Representatives
          </b-badge>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col>
          <Form25RepresentativesResolution :data="getCompanyRepresentatives && getCompanyRepresentatives.data ? getCompanyRepresentatives.data.content : []" badge="Current Company Representatives"/>
        </b-col>
        <b-col>
          <Form25RepresentativesResolution :data="data ? data.representatives : null" badge="New Company Representatives"/>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Form25RepresentativesResolution
  from "@/views/home/services/continuous-filing/task/forms/Form25RepresentativesResolution.vue";
export default {
  name: "ChangeOfRepresentativesForeign",
  components: { Form25RepresentativesResolution },
  props:{
    data:Object,
    brn:String
  },
  mounted() {
    this.fetchCompanyRepresentatives(this.brn)
  },
  methods:{
    ...mapActions(["fetchCompanyRepresentatives"]),
  },
  computed:{
    ...mapGetters(["getCompanyRepresentatives"])
  }
};
</script>

<style scoped>
th, td{
  font-size: 12px;
}

.pdf{
  width: 100%;
  height: 800px;
  overflow-x: auto;
  border:1px solid #b1b1b1;
}
</style>